import script from "./LiteracyTestCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteracyTestCompleted.vue?vue&type=script&setup=true&lang=js"

import "./LiteracyTestCompleted.vue?vue&type=style&index=0&id=1a23188c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a23188c"]])

export default __exports__